import { Action } from "../../store/types";
import {
  ProductCostPolicy,
  DeliverableChargePolicy as DChargePolicy,
  DeliverableTimePolicy as DTimePolicy,
} from "../../models";
import * as actions from "./actions";

export interface SummaryState {
  isTOCChecked: boolean;
  isDataLoading: boolean;
  chargePolicies: DChargePolicy[];
  timePolicies: DTimePolicy[];
  costPolicy?: ProductCostPolicy;
}

const initState: SummaryState = {
  isTOCChecked: false,
  isDataLoading: false,
  chargePolicies: [],
  timePolicies: [],
  costPolicy: undefined,
};

export default function(
  state = initState,
  { type, payload }: Action,
): SummaryState {
  switch (type) {
    case actions.TOGGLE_TOC:
      return { ...state, isTOCChecked: !state.isTOCChecked };
    case actions.SET_DATA_LOADING:
      return { ...state, isDataLoading: payload };
    case actions.SET_CHARGE_POLICIES:
      return { ...state, chargePolicies: payload };
    case actions.SET_TIME_POLICIES:
      return { ...state, timePolicies: payload };
    case actions.SET_COST_POLICY:
      return { ...state, costPolicy: payload };
    case actions.RESET:
      return initState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/WizardSummary/reducer.ts